// MySampleCode.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import './MySampleCode.css'; 

const MySampleCode = () => {
    const myFunction = () => {
        // console.log("Button clicked!");
    };
    return (
        <MainLayout>
            <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
                <div className="dashboard-header">
                    <h3>My Junior Developer</h3>
                </div>
            </div>
            <div className="sample-container">
                <label className="label" htmlFor="username">Input Your Name*</label>
                <input id="username" name="username" value="Input" className="input-field" />
                <label className="label" htmlFor="whoyouare">Select Who You are</label>
                <label className="label" htmlFor="gender">Select Your Gender</label>
                <input id="male" name="gender" value="male" className="input-field" />
                <label className="label" htmlFor="male">Male</label>
                <input id="female" name="gender" value="female" className="input-field" />
                <label className="label" htmlFor="female">Female</label>
                <input id="indian" name="indian" value="indian" className="input-field" />
                <label className="label" htmlFor="indian">I am Indian</label>
                <label className="label" htmlFor="message">Input Your Description</label>
                <textarea id="description" name="description" value="" className="text-area" />
                <button type="button" className="button" onClick={myFunction}>Generate JSX Code</button>
            </div>
        </MainLayout>
    );
};

export default MySampleCode;